export default {
    CLOSE: "Zavřít",
    NEXT: "Další",
    PREV: "Předchozí",
    MODAL: "Toto okno můžete zavřít stisknutím klávesy ESC",
    ERROR: "Někde se něco pokazilo, prosím zkuste akci opakovat později",
    IMAGE_ERROR: "Obrázek nenalezen",
    ELEMENT_NOT_FOUND: "HTML element nenalezen",
    AJAX_NOT_FOUND: "Chyba AJAX načítaní: Not Found",
    AJAX_FORBIDDEN: "Chyba AJAX načítaní: Forbidden",
    IFRAME_ERROR: "Stránku nelze načíst",
    TOGGLE_ZOOM: "Přiblížit/Oddálit",
    TOGGLE_THUMBS: "Zobrazit/Skrýt náhledy",
    TOGGLE_SLIDESHOW: "Spoustit/Zastavit automatické přehrávání",
    TOGGLE_FULLSCREEN: "Režim celé obrazovky",
    DOWNLOAD: "Stáhnout",
};
